import { useInstanceStore } from '../../stores/UseInstanceStore';

/**
 * Dashboard CTA banner shown when user has not created any portfolios yet.
 */
export function OnboardingBanner() {
  const { instance } = useInstanceStore();

  if (instance.onboardingCompleted) return null;

  return (
    <div className="bg-slate-800 border border-cyan-700/50 rounded-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
      <div>
        <h3 className="text-white font-semibold text-sm sm:text-base">Welcome to Katbot</h3>
        <p className="text-slate-400 text-xs sm:text-sm mt-0.5">
          Create your first paper portfolio to start practicing with AI-driven trades.
        </p>
      </div>
    </div>
  );
}
